import React, { useEffect, useState } from "react";

const InputPhNumber = ({
  name,
  value = "",
  onChange,
  placeholder,
  label,
  required = false,
  readOnly,
  setInputNumberError,
}) => {
  const [errMsg, setErrMsg] = useState("");

  const handleBlur = () => {
    const phoneValue = String(value)?.trim();
    if (required && phoneValue === "") {
      setErrMsg("Phone number is required.");
      setInputNumberError((prevState) => ({
        ...prevState,
        phNumber: true,
      }));
    } else if (phoneValue && phoneValue?.length !== 10) {
      setErrMsg("Phone number must be exactly 10 digits.");
      setInputNumberError((prevState) => ({
        ...prevState,
        phNumber: true,
      }));
    } else {
      setErrMsg("");
      setInputNumberError((prevState) => ({
        ...prevState,
        phNumber: false,
      }));
    }
  };
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (/^\d*$/.test(inputValue) && inputValue.length <= 10) {
      onChange({ target: { name, value: inputValue } });
      if (errMsg) {
        setErrMsg("");
        setInputNumberError((prevState) => ({
          ...prevState,
          phNumber: false,
        }));
      }
    }
  };

  useEffect(() => {
    if (!errMsg) {
      setInputNumberError((prevState) => ({
        ...prevState,
        phNumber: false,
      }));
    }
  }, [errMsg, setInputNumberError]);
  return (
    <>
      <div className="form-group">
        <label htmlFor="message-text" className="col-form-label">
          {label}
        </label>
        <input
          type="phone"
          className="form-control"
          name={name}
          value={value}
          onChange={handleInputChange}
          onBlur={handleBlur}
          maxLength={10}
          placeholder={placeholder}
          required={required}
          readOnly={readOnly || false}
        />
      </div>
      <small className="text-danger">{errMsg}</small>
    </>
  );
};

export default InputPhNumber;